import React from "react";

const StepsContext=React.createContext();

export default StepsContext;